import { FunctionComponent, useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { isCep } from "validator-brazil";
import { useCheckout } from "../../context/CheckoutContext";
import styles from "../../pages/CheckoutPayment/CheckoutPagamentoCartao.module.css";
import ApiService from "../../service/ApiService";
import CartCard from "../cartCard/CartCard";
import { useReCaptchaValidation } from "../../hook/useReCaptchaValidation";
import { ecommerceEvents } from "../../utils/gtm";

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const PixPayment: FunctionComponent = ({
  onSwitch,
  openModal,
  setDisabled
} : {
  onSwitch: Function;
  openModal: Function;
  setDisabled: (value: boolean) => void;
}) => {
  const apiService = new ApiService();
  const navigate = useNavigate();
  const params = useParams();
  const {
    isValidReCaptcha,
    validateReCaptcha,
  } = useReCaptchaValidation();

  const { paymentType, totalPrice, setCard, coupon, address, purchaser, card, cart, planId, planName, clientAndAffiliate } = useCheckout();

  const [isCartCardVisible, setIsCartCardVisible] = useState(false)
  const [errors, setErros] = useState({
    cepError: "",
    allFieldsError: "",
  });
  const [cepData, setCepData] = useState({
    cep: "",
    logradouro: "",
    cidade: "",
    complemento: "",
    numero: "",
    bairro: "",
    estado: "",
  });
  const cartCardRef = useRef(null);
  const width = window.innerWidth

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (cartCardRef.current && !cartCardRef.current.contains(event.target)) {
        setIsCartCardVisible(false);
      }
    };
    if (isCartCardVisible) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isCartCardVisible]);

  const openCartCardModal = async () => {
    const isValid = await validateReCaptcha();
    if (isValid) {
      if (!params.slug && !params.planSlug) {
        navigate("/checkout-pagamento-boleto");
      } else if (params.slug && !params.planSlug) {
        navigate(`/checkout-pagamento-boleto/${params.slug}`);
      } else if (params.slug && params.productSlug) {
        navigate(`/checkout-pagamento-boleto/${params.slug}/${params.planSlug}/${params.productSlug}`);
      } else if (params.planSlug && params.productSlug) {
        navigate(`/checkout-pagamento-boleto/${params.planSlug}/${params.productSlug}`);
      }
    }
  };

  const handleSubmitForm = async () => {
    const isValid = await validateReCaptcha();
    
    ecommerceEvents.addPaymentInfo({
      currency: "BRL",
      value: totalPrice,
      shipping_tier: "free",
      coupon: coupon.name? coupon.name : "",
      email: purchaser.email,
      phone: purchaser.telephone.replace(/[()\-\s]/g, ''),
      first_name: purchaser.name,
      last_name: purchaser.lastname,
      afiliado: params.slug? params.slug : clientAndAffiliate.affiliate_id? clientAndAffiliate.affiliate_id : "",
      payment_type: paymentType,
      items: cart.map(item => ({
        item_id: item.id,
        item_name: item.name,
        price: item.price,
        quantity: item.quantity,
        promotion_id: planId,
        promotion_name: planName,
      })),
      shipping_address: {
        city: address.cidade,
        street: address.logradouro,
        number: address.numero,
        state: address.estado,
        neighborhood: address.bairro,
        postal_code: address.cep,
        complement: address.complemento,
      }
    });
    
    if (isValid) {
      if (!params.slug && !params.planSlug) {
        navigate("/checkout-pagamento-processando");
      } else if (params.slug && !params.planSlug) {
        navigate(`/checkout-pagamento-processando/${params.slug}`);
      } else if (params.slug && params.productSlug) {
        navigate(`/checkout-pagamento-processando/${params.slug}/${params.planSlug}/${params.productSlug}`);
      } else if (params.planSlug && params.productSlug) {
        navigate(`/checkout-pagamento-processando/${params.planSlug}/${params.productSlug}`);
      }
    }
  };

  useEffect(() => {
    if (Object.values(errors).some((x) => x !== "")) setDisabled(true);
    else setDisabled(false);
    if (Object.values(cepData).some((x) => x === "")) {
      setDisabled(true);
      setErros({ ...errors, allFieldsError: "Preencha todos os campos" });
    } else {
      setDisabled(false);
      setErros({ ...errors, allFieldsError: "" });
    }
  }, [cepData]);

  return (
    <>
    <div className={styles.dados}>
    <div className={styles.cartaopix}>
        <div className={styles.buttonsPagamento1} 
        onClick={() => onSwitch('Cartão')}>
        <img className={styles.icones2} alt="" src="/icones2.svg" />
        {width < 480 ? <div className={styles.div}>Crédito</div> : 
             <div className={styles.div}>Cartão de crédito</div>
              }
        </div>
        <div className={paymentType === 'Boleto' ? styles.buttonsPagamento: styles.buttonsPagamento1} 
        onClick={() => onSwitch('Boleto')}>
          <img className={styles.icones3} alt="" src="/codigo-de-barras.png" />
          <div className={styles.div}>Boleto</div>
        </div>
        <div className={paymentType === 'Pix' ? styles.buttonsPagamento: styles.buttonsPagamento1} 
        onClick={() => onSwitch('Pix')}>
          <img className={styles.icones2} alt="" src="/icones12.svg" />
          <div className={styles.div}>PIX</div>
          <img className={styles.pixDiscount} alt="" src="/pix_frame.png" />
        </div>
    </div>
      <div className={styles.observacoes}>
        <div className={styles.div}>Observações</div>
        <div className={styles.aoConfirmarO}>
          {paymentType === 'Pix'
            ? 'Ao confirmar o pagamento via PIX, será gerado um PIX Copia e Cola para visualização. Basta copiar o código referente ao QR Code e informar esse código dentro da área PIX do aplicativo do seu benco'
            : 'Ao confirmar o pagamento via boleto, será gerado um código de barras para visualização. Basta copiar o código de barras e informar dentro do aplicativo do seu banco para prosseguir com o seu pagamento.'
          }
        </div>
      </div>
    </div>
    {width > 800 && (
      <div className={styles.cta} onClick={width < 800 ? () => openModal() : handleSubmitForm}>
        <div className={styles.div}>Finalizar compra</div>
        <img className={styles.icones} alt="" src="/icones5.svg" />
      </div>
    )}

    {isCartCardVisible && (
          <div
            className={`${styles.cartCardModal} ${
              isCartCardVisible ? styles.showModal : ""
            }`}
          >
            <div className={styles.cartCardContent} ref={cartCardRef}>
              <CartCard showProducts={true} />
              <div className={styles.btnFinish} onClick={openCartCardModal}>
                <div className={styles.yelly}>Finalizar compra</div>
              </div>
            </div>
          </div>
        )}
    </>
  );
};

export default PixPayment;